import { apiShops } from '@/api/api-shops.js'
import optionsToQuery from '@/utils/common.js'

const shopsMutations = {
  shops_set(state, shops){
    state.shops = shops;
  },

  shops_insert(state, shop){
    state.shops.items = [...state.shops.items, shop];
  },

  shop_extract(state, shop){
    state.shops.items = state.shops.items.filter(item => item.id !== shop.id)
  },

  shops_update(state, shop){
    state.shops.items = state.shops.items.map(item => item.id == shop.id ? shop : item)
  },

  shops_set_template(state, template){
    state.template = template
  }
}

const shopsActions = {
  async shop_list({commit}, payload){
    let query;
    if(payload){
      query = optionsToQuery(payload);
    }
    const result = await apiShops.list(query);
    commit('shops_set', result);
  },

  async shop_by_id({commit}, payload){
    const result = await apiShops.get(payload);
    commit('shops_insert', result);
  },

  async shop_create({commit}, payload){
    const result = await apiShops.create(payload);
    commit('shops_insert', result);
  },

  async shop_update({commit}, payload){
    console.log('payload', payload)
    const result = await apiShops.update(payload);
    commit('shops_update', result);
  },

  async shop_deactivate({commit}, payload){
    const result = await apiShops.deactivate(payload);
    commit('shops_update', result);
  },

  async shop_delete({commit}, payload){
    commit('shop_extract', payload);
    await apiShops.delete(payload);
  },

  async shop_search({commit}, payload){
    let query;
    if(payload){
      query = optionsToQuery(payload.options);
    }
    const result = await apiShops.search(payload.query, query);
    commit('shops_set', result)
  },

  async shop_template({commit}){
    const result = await apiShops.template();
    commit('shops_set_template', result);
  }
}

export {
  shopsActions,
  shopsMutations
}